import { render, staticRenderFns } from "./ModalTransmissionEdit.vue?vue&type=template&id=9f4d1482&"
import script from "./ModalTransmissionEdit.vue?vue&type=script&lang=js&"
export * from "./ModalTransmissionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports